import * as React from 'react';
import { AppProps, AppState } from '../components/app';
import CalendarContainer from '../components/buytickets-container';
import FiltersContainer from '../components/filters/container';
import FiltersTagContainer from '../components/filters/filter-tags'; 
import { disableTabbableChildren } from '../../../static/javascript/helpers/disabletabbablechildren'; 
import { stickyFilters } from '../../shared/helpers/sticky-filters';


export class AppView extends React.Component<AppProps, AppState> {
    public navTop;
    public calFiltersContainer;
    public calFiltersHeight;
    public topNavHeight;
    public filtersAmount;
    public calendarViewMode;
    public filtersShouldStick;
    public buyTicketsPoster: HTMLElement;
    public followPoster: boolean;
    public filtersAccordion;
    constructor(props: AppProps) {
        super(props);
        this.followPoster = true;
        this.state = {
            filtersShouldStick: false,
            filtersAmount: 0
        };
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        this.topNavHeight = document.getElementById('header').getBoundingClientRect().height;
        if (!this.calFiltersContainer) {
            this.calFiltersContainer = document.querySelector('#aceCalFiltersContainer');
            this.calFiltersHeight = this.calFiltersContainer.getBoundingClientRect().height;
        }
        this.filtersAccordion = (document.querySelector('#filters') as HTMLElement);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    closeAccordion(accordionToClose) {
        accordionToClose.setAttribute('style', 'height: 0px');
        accordionToClose.setAttribute('aria-hidden', 'true');
        disableTabbableChildren(accordionToClose);
        let id = accordionToClose.id;
        document.querySelector('[aria-controls="' + id + '"]').setAttribute('aria-expanded', 'false');
    }

    stickPoster() {
        if (this.buyTicketsPoster) {
            document.querySelector('body').classList.add('sticky-poster');
        }
    }

    unstickPoster() {
        if (this.buyTicketsPoster) {
            document.querySelector('body').classList.remove('sticky-poster');
        }
    }

    handleScroll = () => {
        window.requestAnimationFrame(() => {
            if (!this.buyTicketsPoster) {
                this.buyTicketsPoster = document.getElementById('buyTicketsPoster');
            }

            window.requestAnimationFrame(() => {
                let stick = false;
                const filterNav = document.getElementById('filtersNav');
                if (this.calFiltersContainer.getBoundingClientRect().top <= this.topNavHeight) {
                    stick = true;
                    this.calFiltersContainer.style.height = filterNav.getBoundingClientRect().height + 'px';
                }
                else {
                    stick = false;
                    this.calFiltersContainer.removeAttribute('style');
                }
                if (this.followPoster) {
                    const headerHeight = document.getElementById('header').getBoundingClientRect().height + (document.querySelector('#lyricAlert[aria-hidden=false]') ? document.querySelector('#lyricAlert[aria-hidden=false]').getBoundingClientRect().height : 0);
                    if (this.buyTicketsPoster.getBoundingClientRect().top < -(this.buyTicketsPoster.getBoundingClientRect().height - headerHeight)) {
                        this.stickPoster();
                        this.followPoster = false;
                    }
                }
                else {
                    if (this.calFiltersContainer.getBoundingClientRect().bottom > document.getElementById('header').getBoundingClientRect().bottom) {
                        this.unstickPoster();
                        this.followPoster = true;
                    }
                }
                const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                if (windowWidth > 1024) {
                    if (stick) {
                        const accordionToToggle = document.querySelector('#filters');
                        const accordionAriaHidden = accordionToToggle.getAttribute('aria-hidden');
                        if (accordionAriaHidden != null && accordionAriaHidden === 'false') {
                            this.closeAccordion(accordionToToggle);
                        }
                    }
                    this.setState({
                        filtersShouldStick: stickyFilters(this.calFiltersContainer, this.topNavHeight, this.filtersAccordion, () => { this.closeAccordion(this.filtersAccordion) })
                    });
                }
            });
            
        });
    };

    render() {
        return (
            <section className="ace-cal">
                
                <div id="aceCalFiltersContainer" className="filters-container">
                    <nav id="filtersNav" className={this.state.filtersShouldStick ? 'filters-sticky' : ''}>
                        <h2 className="visually-hidden">Buy Tickets Filters</h2>
                        <ul className={`adage-accordion-inner filters-accordion`} data-accordion-list="filtersAccordion">
                            <li className="adage-accordion-item">
                                <button className="adage-accordion-trigger" type="button" aria-controls="filters">
                                    Filter
                                </button>
                                <div className="adage-accordion-panel" aria-hidden="true" id="filters">
                                    <div className="adage-accordion-panel-content">
                                        <FiltersContainer />
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <FiltersTagContainer />
                    </nav>
                </div>
                <div aria-live="polite">
                    <CalendarContainer />
                </div>
            </section>);
    }   
}

export default AppView;